module.exports = __webpack_public_path__ + "static/media/decision_making_1.d11f6342.png";